module.exports = __webpack_public_path__ + "static/media/OCT.791eea6c.jpg";